import { render } from "./categorylessTemplate.vue?vue&type=template&id=4a1c4920&scoped=true"
import script from "./categorylessTemplate.vue?vue&type=script&lang=js"
export * from "./categorylessTemplate.vue?vue&type=script&lang=js"

import "./categorylessTemplate.vue?vue&type=style&index=0&id=4a1c4920&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1c4920"]])

export default __exports__